/* eslint-disable camelcase */
export const emitGAEvent = (category, label, value, eventName) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      event_category: category,
      event_label: label,
      value,
    });
  }
};
